export default __webpack_public_path__ + "static/media/orc.9e6d9c99.png";